import React from 'react'
import moment from 'moment'
import Utilities from '../../../../../services/commonservice/utilities'
import { useMediaQuery } from 'react-responsive';
import AppointmentButtonGroup from '../../../../../services/commonservice/appointment-button-group.utility'
const AppointmentCard = (props) => {
    let startTime = moment(props.appointment.fromDate).format('h:mm')
    let endTime = moment(props.appointment.toDate).format('h:mm A')
    const isMobile = useMediaQuery({ query: `(max-width: 576px)` });

    return (
        <div>
            <div className="row-fluid ui segment">
                <div className='btn p-0 col-12 justify-content-start align-items-start'>
                    <div className='row d-flex align-items-start'>
                        {!isMobile && props.appointment.parentGroupId && <span className="col-lg-2 col-md-6 col-12"><i className="icon angle right"></i></span>}
                        {!props.appointment.parentGroupId && <span className="col-lg-2 col-md-6 col-12 text-start pe-0">
                            {props.appointment.providerRequested === 1 && <i className='ui icon' title='Provider Requested'><b>R</b></i>}{props.appointment.firstName} {props.appointment.lastName}</span>}
                        <span className="col-lg-2 col-md-6 col-12 text-start pe-0">{props.appointment.drFirstName} {props.appointment.drLastName}</span>
                        <span className="col-lg-2 col-md-6 col-12 text-start pe-0">{!props.appointment.parentGroupId && props.appointment.appointmentStatusCode}</span>
                        <span className="col-lg-2 col-md-6 col-12 text-start pe-0">{props.appointment.practiceServiceType}</span>
                        <span className="col-lg-2 col-md-6 col-12 text-start pe-0">{startTime}-{endTime}</span>
                        {!props.appointment.parentGroupId && <div className='col-lg-2 col-md-6 col-12'>
                            <div className={`row ${isMobile ? '' : 'justify-content-end'}`}>
                                <div class="col-auto btn-group">
                                    <AppointmentButtonGroup
                                        buttonClass={'p-0 ps-1'}
                                        initialData={props?.appointment}
                                        //extraButton={extraButtons}
                                        refresh={() => { props.refresh() }}
                                    ></AppointmentButtonGroup>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
                {/* {open && <div className='col-12 d-flex justify-content-between align-items-center mt-3'>
                </div>} */}
                {!props.appointment.parentGroupId && props.appointment.patientOpenBalance && <><hr /><div className='btn p-0 col-12 d-flex justify-content-between align-items-center'>
                    <div className='col-12 row d-flex align-items-center'>
                        <div className='col-lg-6 col-md-6 col-12 text-start'>Open Balance: {Utilities.toDollar(props.appointment.patientOpenBalance)}
                        </div>
                    </div>
                </div></>}
            </div>
        </div >
    )
}

export default AppointmentCard